"use client"

import { runOnceInBrowser } from "src/utilities/runOnceInBrowser"
import { IntegrationScript } from "../lib/IntegrationScript"

const src = "https://connect.facebook.net/en_US/fbevents.js"

export const MetaPixelTag = () => {
  return <IntegrationScript id="meta_pixel" src={src} />
}

runOnceInBrowser("initFbq", () => {
  ;((window: Window & { fbq?: any; _fbq?: any }, fbq?: any): void => {
    if (window.fbq) return

    fbq = window.fbq = (...args: any[]) => {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue.push(args)
      }
    }

    if (!window._fbq) window._fbq = fbq

    fbq.push = fbq
    fbq.loaded = true
    fbq.version = "2.0"
    fbq.queue = []

    // Manually track page views in single-page applications.
    // https://developers.facebook.com/ads/blog/post/2017/05/29/tagging-a-single-page-application-facebook-pixel/
    fbq.disablePushState = true
  })(window)
})
